import type { GroupLike, SubGroup } from '../types.ts';
import { extractNonEmptyGroup } from './extractNonEmptyGroup.ts';

export const filterNonEmptyGroups = (groups: GroupLike[]): Omit<GroupLike, 'uuid'>[] => {
  return groups.reduce<Omit<GroupLike, 'uuid'>[]>((acc, group) => {
    if ('groups' in group) {
      const subgroup: Omit<SubGroup, 'uuid'> = {
        operator: group.operator,
        groups: [],
      };

      group.groups.forEach(sub => {
        const filtered = extractNonEmptyGroup(sub);

        if (filtered) {
          subgroup.groups.push(filtered);
        }
      });

      if (subgroup.groups.length) {
        acc.push(subgroup);
      }
    } else {
      const filtered = extractNonEmptyGroup(group);

      if (filtered) {
        acc.push(filtered);
      }
    }

    return acc;
  }, []);
};
